import type { Prisma } from "@repo/database";
import type { BuyBoxListingFacts } from "./fit";

/** The listing columns fit scoring reads. */
export const buyBoxListingFactsSelect = {
  id: true,
  businessTypeId: true,
  businessType: { select: { name: true } },
  askingPrice: true,
  revenue: true,
  sde: true,
  ebitda: true,
  sbaPrequalified: true,
  financingAvailable: true,
  business: {
    select: {
      address: {
        select: {
          city: true,
          state: true,
          country: { select: { code: true } },
          subdivision: {
            select: {
              id: true,
              parentId: true,
              parent: {
                select: {
                  parentId: true,
                  parent: { select: { parentId: true } },
                },
              },
            },
          },
        },
      },
    },
  },
} satisfies Prisma.ListingSelect;

export type BuyBoxListingRow = Prisma.ListingGetPayload<{
  select: typeof buyBoxListingFactsSelect;
}>;

const toNumber = (value: bigint | null) =>
  value == null ? null : Number(value);

export function toBuyBoxListingFacts(
  listing: BuyBoxListingRow,
): BuyBoxListingFacts {
  const address = listing.business?.address;
  const subdivision = address?.subdivision;
  const subdivisionIds = [
    subdivision?.id,
    subdivision?.parentId,
    subdivision?.parent?.parentId,
    subdivision?.parent?.parent?.parentId,
  ].filter((id): id is number => id != null);
  const locationLabel =
    [address?.city, address?.state].filter(Boolean).join(", ") || null;

  return {
    businessTypeId: listing.businessTypeId,
    businessTypeName: listing.businessType?.name ?? null,
    countryCode: address?.country?.code ?? null,
    subdivisionIds,
    locationLabel,
    askingPrice: toNumber(listing.askingPrice),
    revenue: toNumber(listing.revenue),
    sde: toNumber(listing.sde),
    ebitda: toNumber(listing.ebitda),
    sbaPrequalified: listing.sbaPrequalified,
    financingAvailable: listing.financingAvailable,
  };
}
